import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form, Modal, Row, Select, Upload, Button, Col } from 'antd'
import { SketchPicker } from 'react-color'
import { CameraOutlined, UploadOutlined } from '@ant-design/icons'

import { AButton } from 'src/components/atoms/Button'
import { FormItem } from 'src/components/molecules/FormItem'
import { rules } from 'src/utils/rules'

import settingData from './settingData.json'

export const CreateSettingQR = ({
  onFinish,
  loading,
  form,
  visible,
  onCancel
}) => {
  const [select, setSelect] = useState('DEFAULT')
  const [size, setSize] = useState('')
  const [showCustomClaimButton, setShowCustomClaimButton] = useState('DEFAULT')
  const [showCustomSubmitButton, setShowCustomSubmitButton] = useState('DEFAULT')
  const [buttonColor, setButtonColor] = useState('#4F55F2')
  const [showColorPicker, setShowColorPicker] = useState(false)

  useEffect(() => {
    if (size === 'MEDIUM') {
      const newData = {
        ...form,
        textInQrcode: 'SCAN QR CODE INI UNTUK KEASLIAN PRODUK'
      }

      form.setFieldsValue(newData)
    }
  }, [size])

  const onSubmit = async () => {
    await onFinish()
    setSelect('')
    setSize('')
  }

  const close = () => {
    onCancel()
    setSelect('')
    setSize('')
  }

  const withCustomText = (size) => {
    switch (size) {
      case 'A4_1_FOR_1_PAGE_QR_20x20_TEXT':
        return true
      case 'A4_1_FOR_1_PAGE_QR_40x40_TEXT':
        return true
      case 'MEDIUM':
        return true
      case 'A0_10x10_TEXT':
        return true
      case 'A4_10x10_TEXT':
        return true
      default:
        return false
    }
  }

  const handleColorChange = (color) => {
    setButtonColor(color.hex)
    form.setFieldsValue({ buttonColor: color.hex })
  }

  const buttonPositionOptions = [
    {
      value: 'left',
      label: 'Left'
    },
    {
      value: 'center',
      label: 'Center'
    },
    {
      value: 'right',
      label: 'Right'
    }
  ]

  const buttonVerticalPositionOptions = [
    {
      value: 'top',
      label: 'Top'
    },
    {
      value: 'bottom',
      label: 'Bottom'
    }
  ]

  return (
    <Modal
      title='Create Setting QR'
      visible={visible}
      footer={false}
      onCancel={close}
      wrapClassName='modal-setting-qr'
    >
      <Form form={form} onFinish={onSubmit} layout='vertical'>
        <Form.Item name='logo' label='Logo' rules={[rules.required]}>
          <Upload
            beforeUpload={() => false}
            listType='picture-card'
            maxCount={1}
            accept='image/jpg,image/png,image/jpeg'
          >
            <CameraOutlined />
          </Upload>
        </Form.Item>
        <FormItem
          name='name'
          label='Name'
          placeholder='Setting name'
          rules={[rules.required]}
        />
        <FormItem
          name='size'
          label='QR Size'
          placeholder='Choose qr size'
          select
          onChange={(e) => setSize(e)}
          rules={[rules.required]}
        >
          {settingData.map((setting) => (
            <Select.Option key={setting.size}>{setting.label}</Select.Option>
          ))}
        </FormItem>
        <FormItem
          name='type'
          label='Scan Page'
          placeholder='Choose scan page'
          select
          onChange={(e) => setSelect(e)}
          initialValue={select}
          rules={select !== 'DEFAULT' ? [rules.required] : []}
        >
          <Select.Option key='DEFAULT'>Default</Select.Option>
          <Select.Option key='CUSTOM'>Custom Page</Select.Option>
          <Select.Option key='IMAGE'>Custom Image</Select.Option>
        </FormItem>
        {select === 'CUSTOM' && (
          <FormItem
            name='url'
            label='Custom URL Scan Page'
            placeholder='eg: https://example.com/product'
            rules={[rules.required]}
          />
        )}
        {select === 'IMAGE' && (
          <Form.Item
            label='Custom Image Scan Page'
            name='imageScanPage'
            rules={[rules.required]}
          >
            <Upload
              beforeUpload={() => false}
              listType='picture-card'
              maxCount={1}
              accept='image/*'
            >
              <CameraOutlined />
            </Upload>
          </Form.Item>
        )}
        {withCustomText(size) && (
          <FormItem
            name='textInQrcode'
            label='Custom Text Scan QR Code '
            placeholder='SCAN QR CODE INI UNTUK KEASLIAN PRODUK'
            value='SCAN QR CODE INI UNTUK KEASLIAN PRODUK'
            textarea
          />
        )}
        <Form.Item label='Auto-Downloading Document' name='document'>
          <Upload beforeUpload={() => false} maxCount={1} accept='.pdf'>
            <Button icon={<UploadOutlined />}>Click to upload</Button>
          </Upload>
        </Form.Item>
        <FormItem
          name='showCustomClaimButton'
          label='Custom Button Claim Coupon'
          select
          onChange={(e) => setShowCustomClaimButton(e)}
          initialValue={showCustomClaimButton}
          rules={showCustomClaimButton !== 'DEFAULT' ? [rules.required] : []}
        >
          <Select.Option key='DEFAULT'>Default</Select.Option>
          <Select.Option key='CUSTOM'>Custom</Select.Option>
        </FormItem>
        {showCustomClaimButton !== 'DEFAULT' && (
          <>
            <Row gutter={16}>
              <FormItem
                col={16}
                label='Button Text'
                name='buttonText'
                tooltip='Custom text for the claim button'
                initialValue='CLAIM COUPON'
                rules={[rules.required]}
              />
              <Col span={8}>
                <Form.Item
                  label='Button Color'
                  name='buttonColor'
                  rules={[rules.required]}
                  initialValue={buttonColor}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        padding: '5px',
                        background: '#fff',
                        borderRadius: '1px',
                        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                        display: 'inline-block',
                        cursor: 'pointer'
                      }}
                      onClick={() => setShowColorPicker(!showColorPicker)}
                    >
                      <div
                        style={{
                          width: '36px',
                          height: '14px',
                          borderRadius: '2px',
                          background: buttonColor
                        }}
                      />
                    </div>
                    <span style={{ marginLeft: '10px', fontSize: '14px' }}>
                      {buttonColor}
                    </span>
                    {showColorPicker && (
                      <div style={{ position: 'absolute', zIndex: 2 }}>
                        <div
                          style={{
                            position: 'fixed',
                            top: '0px',
                            right: '0px',
                            bottom: '0px',
                            left: '0px'
                          }}
                          onClick={() => setShowColorPicker(false)}
                        />
                        <div style={{ position: 'relative' }}>
                          <a
                            href='#'
                            onClick={() => setShowColorPicker(false)}
                            style={{
                              backgroundColor: '#FF0000',
                              position: 'absolute',
                              top: '-15px',
                              right: '-15px',
                              border: 'none',
                              borderRadius: '100%',
                              fontSize: '16px',
                              cursor: 'pointer',
                              zIndex: 3,
                              color: '#fff',
                              fontWeight: 'bold',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '0 7px 0 7px'
                            }}
                          >
                            ×
                          </a>
                          <SketchPicker
                            color={buttonColor}
                            onChange={handleColorChange}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <FormItem
                col={12}
                label='Horizontal Position'
                name='buttonHorizontalPosition'
                select
                initialValue='right'
                placeholder='Select position'
                rules={[rules.required]}
              >
                {buttonPositionOptions.map((item, index) => (
                  <Select.Option key={index} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </FormItem>
              <FormItem
                col={12}
                label='Vertical Position'
                name='buttonVerticalPosition'
                select
                initialValue='bottom'
                placeholder='Select position'
                rules={[rules.required]}
              >
                {buttonVerticalPositionOptions.map((item, index) => (
                  <Select.Option key={index} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </FormItem>
            </Row>
          </>
        )}
        <FormItem
          name='showCustomSubmitButton'
          label='Custom Submit Claim Coupon'
          select
          onChange={(e) => setShowCustomSubmitButton(e)}
          initialValue={showCustomSubmitButton}
          rules={showCustomSubmitButton !== 'DEFAULT' ? [rules.required] : []}
        >
          <Select.Option key='DEFAULT'>Default</Select.Option>
          <Select.Option key='CUSTOM'>Custom</Select.Option>
        </FormItem>
        {showCustomSubmitButton !== 'DEFAULT' && (
          <FormItem
            name='customSubmitText'
            label='Submit Button Text'
            placeholder='Submit'
            initialValue='Submit'
            rules={[rules.required]}
          />
        )}
        <Row justify='end'>
          <AButton loading={loading} type='primary' title='Submit' />
        </Row>
      </Form>
    </Modal>
  )
}

CreateSettingQR.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onFinish: PropTypes.func,
  loading: PropTypes.bool,
  form: PropTypes.object
}
